/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ComplianceStandardsResponse {
    getFixupPrototypeFunction() { return ComplianceStandardsResponse.fixupPrototype; }

    static newInstance(model: Partial<ComplianceStandardsResponse>): ComplianceStandardsResponse {
        let obj = Object.assign(new ComplianceStandardsResponse(), model);
        ComplianceStandardsResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ComplianceStandardsResponse>): ComplianceStandardsResponse {
        if (!model) return null;
        return ComplianceStandardsResponse.newInstance(<ComplianceStandardsResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ComplianceStandardsResponse) {
        if (!obj) return;

        models.ComplianceStandardsResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ComplianceStandardsResponse): boolean {
        Object.setPrototypeOf(obj, ComplianceStandardsResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.data) {
            for (let val of this.data) {
                models.ComplianceStandards.fixupPrototype(val);
            }
        }
    }

    /**
     * Response status for compliance standards
     */
    status: string;

    /**
     * Response message for compliance standards
     */
    message: string;

    /**
     * Compliance Standards data list
     */
    data: Array<models.ComplianceStandards>;

}
